import { NgModule, Component, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA  } from "@angular/core";
import { DateAdapter } from '@angular/material';
import { RouterModule } from "@angular/router";
import { DxChartModule, DxPieChartModule } from 'devextreme-angular';
import { SharedModule } from "../../core/modules/shared.module";
import { FuseWidgetModule } from "../../core/components/widget/widget.module";
import { LoginComponent } from "./components/login/login.component";
import { FuseForgotPasswordComponent } from "./components/forgot-password/forgot-password.component";
import { DashboardComponent } from "./components/dashboard/dashboard.component";
import { ChangePasswordComponent } from "./components/change-password/change-password.component";
import { Login, mUser, zRolePageAccess } from "./models/user.model";
import { UserService } from "./services/user.service";
import { AppService } from "./services/app.service";
import { UserComponent } from "./components/user/user.component";
import { Datatable, SecDatatable } from "./models/datatable.model";
import { DataTableComponent } from "./components/datatable/datatable.component";
import { UserEditFormComponent } from "./components/user/user-edit-form/user-edit-form.component";
import { UserActionsFormComponent } from "./components/user/user-actions-form/user-actions-form.component";
import { OrderComponent } from "./components/order/order.component";
import { OrderRemarkComponent } from "./components/order-remark/order-remark.component";
import { OrderEditFormComponent } from "./components/order/order-edit-form/order-edit-form.component";
import { OrderService } from "./services/order.service";
import { OrderDetailComponent } from "./components/order/order-edit-form/order-detail/order-detail.component";
import { CustomerDetailComponent } from "./components/order/order-edit-form/customer-detail/customer-detail.component";
import { DeliveryDetailComponent } from "./components/order/order-edit-form/delivery-detail/delivery-detail.component";
import { PaymentDetailComponent } from "./components/order/order-edit-form/payment-detail/payment-detail.component";
import { FinancialDetailComponent } from "./components/order/order-edit-form/financial-detail/financial-detail.component";
import {
  DocumentDetail,
  Order,
  OrderRemark
} from "./models/order.model";
import { DocumentDetailComponent } from "./components/order/document-detail/document-detail.component";
import { DistributorComponent } from "./components/distributor/distributor.component";
import { DistributorEditFormComponent } from "./components/distributor/distributor-edit-form/distributor-edit-form.component";
import { DistributorRegionFormComponent } from "./components/distributor/distributor-region-form/distributor-region-form.component";
import { DistributorService } from "./services/distributor.service";
import { Distributor } from "./models/distributor.model";
import { ComponentService } from "./services/component.service";
import { MasterService } from "./services/master.service";
import { DashboardService } from "./services/dashboard.service";
import { ShipperComponent } from "./components/shipper/shipper.component";
import { ShipperEditFormComponent } from "./components/shipper/shipper-edit-form/shipper-edit-form.component";
import { ShipperService } from "./services/shipper.service";
import { Shipper } from "./models/shipper.model";
import { GeneralComponent } from "./components/general/general.component";
import { GeneralEditFormComponent } from "./components/general/general-edit-form/general-edit-form.component";
import { LanguageEditFormComponent } from "./components/general/language-edit-form/language-edit-form.component";
import { PageAccessEditFormComponent } from "./components/general/page-access-edit-form/page-access-edit-form.component";
import { DashboardTilesEditFormComponent } from "./components/general/dashboard-tiles-edit-form/dashboard-tiles-edit-form.component";
import { SharedService } from "./services/shared";
import { OrderCustomsFormComponent } from "./components/order/order-customs-form/order-customs-form.component";
import { TextMaskModule } from "angular2-text-mask";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { SecondaryDatatableComponent } from './components/secondary-datatable/secondary-datatable.component';
import { DistributorOrderComponent } from './components/distributor-order/distributor-order.component';
import { DistributorOrderEditFormComponent } from './components/distributor-order/distributor-order-edit-form/distributor-order-edit-form.component';
import { DistCustomerDetailComponent } from './components/distributor-order/distributor-order-edit-form/dist-customer-detail/dist-customer-detail.component';
import { DistDeliveryDetailComponent } from './components/distributor-order/distributor-order-edit-form/dist-delivery-detail/dist-delivery-detail.component';
import { DistFinancialDetailComponent } from './components/distributor-order/distributor-order-edit-form/dist-financial-detail/dist-financial-detail.component';
import { DistOrderDetailComponent } from './components/distributor-order/distributor-order-edit-form/dist-order-detail/dist-order-detail.component';
import { DistPaymentDetailComponent } from './components/distributor-order/distributor-order-edit-form/dist-payment-detail/dist-payment-detail.component';
import { FinanceComponent } from './components/finance/finance.component';
import { FinanceShipperComponent } from './components/finance-shipper/finance-shipper.component';
import { FinanceService } from "./services/finance.service";
import { ScrumBreadBarComponent } from './components/scrum-bread-bar/scrum-bread-bar.component';
import { BillofloadingComponent } from './components/billofloading/billofloading.component';
import { ReportService } from "./services/reports.service";
import { SystemDataService } from "./services/systemdata.service";
import { FileDropModule } from 'ngx-file-drop';
import { OrderChartComponent } from './components/dashboard/order-chart/order-chart.component';
import { MaintainanceComponent } from './components/maintainance/maintainance.component';
import { SummaryChartComponent } from './components/order/summary-chart/summary-chart.component';
import { DistSummaryChartComponent } from './components/distributor-order/dist-summary-chart/dist-summary-chart.component';
import { ApiUserDetailsComponent } from './components/distributor/api-user-details/api-user-details.component';
import { ApiUserDetailsService } from "./services/api.user.details.service";
import { ApiUserDetailsEditFormComponent } from './components/distributor/api-user-details/api-user-details-edit-form/api-user-details-edit-form.component';



const routes = [
  { path: "", redirectTo: "/login", pathMatch: "full" },
  { path: "login", component: LoginComponent },
  {
    path: "wachtwoord-opnieuw-instellen",
    component: FuseForgotPasswordComponent
  },
  { path: "dashboard", component: DashboardComponent },
  { path: "user", component: UserComponent },
  { path: "order", component: OrderComponent },
  { path: "resetpassword", component: FuseForgotPasswordComponent },
  { path: "distributor", component: DistributorComponent },
  { path: "shipper", component: ShipperComponent },
  { path: "country", component: GeneralComponent },
  { path: "city", component: GeneralComponent },
  { path: "role", component: GeneralComponent },
  { path: "postalcode", component: GeneralComponent },
  { path: "region", component: GeneralComponent },
  { path: "canton", component: GeneralComponent },
  { path: "distorder", component: DistributorOrderComponent },
  { path: "finance", component: FinanceComponent },
  { path: "fshipper", component: FinanceShipperComponent },
  { path: "billofloading", component: BillofloadingComponent },
  { path: "apiuserdetails", component: ApiUserDetailsComponent },
];

@NgModule({
  declarations: [
    LoginComponent,
    FuseForgotPasswordComponent,
    DashboardComponent,
    ChangePasswordComponent,
    UserComponent,
    DataTableComponent,
    UserEditFormComponent,
    UserActionsFormComponent,
    OrderComponent,
    OrderRemarkComponent,
    OrderEditFormComponent,
    OrderDetailComponent,
    CustomerDetailComponent,
    DeliveryDetailComponent,
    PaymentDetailComponent,
    FinancialDetailComponent,
    DocumentDetailComponent,
    DistributorComponent,
    DistributorEditFormComponent,
    DistributorRegionFormComponent,
    ShipperComponent,
    ShipperEditFormComponent,
    GeneralComponent,
    GeneralEditFormComponent,
    LanguageEditFormComponent,
    PageAccessEditFormComponent,
    DashboardTilesEditFormComponent,
    OrderCustomsFormComponent,
    SecondaryDatatableComponent,
    DistributorOrderComponent,
    DistributorOrderEditFormComponent,
    DistCustomerDetailComponent,
    DistDeliveryDetailComponent,
    DistFinancialDetailComponent,
    DistOrderDetailComponent,
    DistPaymentDetailComponent,
    FinanceComponent,
    FinanceShipperComponent,
    ScrumBreadBarComponent,
    BillofloadingComponent,
    OrderChartComponent,
    MaintainanceComponent,
    SummaryChartComponent,
    DistSummaryChartComponent,
    ApiUserDetailsComponent,
    ApiUserDetailsEditFormComponent
  ],
  imports: [
    SharedModule,
    RouterModule.forChild(routes),
    FuseWidgetModule,
    TextMaskModule,
    NgxMatSelectSearchModule,
    FileDropModule,
    DxChartModule,
    DxPieChartModule
  ],
  providers: [
    DataTableComponent,
    ChangePasswordComponent,
    Login,
    UserService,
    AppService,
    mUser,
    zRolePageAccess,
    Datatable,
    OrderService,
    DocumentDetail,
    DistributorService,
    Distributor,
    ComponentService,
    MasterService,
    DashboardService,
    ShipperService,
    Shipper,
    Order,
    OrderRemark,
    SharedService,
    SecondaryDatatableComponent,
    SecDatatable,
    FinanceService,
    ReportService,
    SystemDataService,
    ApiUserDetailsService
  ],
  entryComponents: [
    ChangePasswordComponent,
    UserEditFormComponent,
    UserActionsFormComponent,
    OrderEditFormComponent,
    DocumentDetailComponent,
    DistributorEditFormComponent,
    DistributorRegionFormComponent,
    ShipperEditFormComponent,
    GeneralEditFormComponent,
    LanguageEditFormComponent,
    PageAccessEditFormComponent,
    DashboardTilesEditFormComponent,
    OrderCustomsFormComponent,
    DistributorOrderEditFormComponent,
    OrderRemarkComponent,
    MaintainanceComponent,
    SummaryChartComponent,
    DistSummaryChartComponent,
    ApiUserDetailsEditFormComponent
  ],
  schemas: [
        NO_ERRORS_SCHEMA,
        CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class ContentModule {}



// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/content.module.ts